'use client';

import { Check } from 'lucide-react';
import { WIZARD_STEPS, useSignupWizard } from '@/stores/signupWizardStore';

export function WizardProgressBar() {
  const currentStep = useSignupWizard((s) => s.currentStep);
  const completedSteps = useSignupWizard((s) => s.completedSteps);
  const setStep = useSignupWizard((s) => s.setStep);

  return (
    <nav className="w-full" aria-label="Signup progress">
      <ol className="hidden md:flex items-center">
        {WIZARD_STEPS.map((step, i) => {
          const isComplete = completedSteps.includes(i);
          const isCurrent = currentStep === i;
          const isClickable = isComplete || isCurrent || completedSteps.includes(i - 1);

          return (
            <li key={step.id} className="flex flex-1 items-center">
              <button
                onClick={() => isClickable && setStep(i)}
                disabled={!isClickable}
                className={`group flex flex-col items-center gap-2 transition ${
                  isClickable ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'
                }`}
              >
                <div
                  className={`flex h-10 w-10 items-center justify-center rounded-full border-2 text-sm font-semibold transition-all ${
                    isComplete
                      ? 'border-emerald-500 bg-emerald-500 text-white'
                      : isCurrent
                        ? 'border-emerald-500 bg-white text-emerald-600 shadow-md shadow-emerald-500/20'
                        : 'border-slate-200 bg-white text-slate-400'
                  }`}
                >
                  {isComplete ? <Check className="h-5 w-5" /> : i + 1}
                </div>
                <div className="text-center">
                  <p className={`text-xs font-semibold ${isCurrent ? 'text-emerald-600' : isComplete ? 'text-slate-700' : 'text-slate-400'}`}>
                    {step.label}
                  </p>
                  <p className="text-[10px] text-slate-400 hidden lg:block">{step.description}</p>
                </div>
              </button>
              {i < WIZARD_STEPS.length - 1 && (
                <div className="flex-1 mx-2">
                  <div className={`h-0.5 w-full rounded-full transition-colors ${isComplete ? 'bg-emerald-500' : 'bg-slate-200'}`} />
                </div>
              )}
            </li>
          );
        })}
      </ol>

      <div className="flex items-center justify-between md:hidden">
        <p className="text-sm font-semibold text-slate-900">Step {currentStep + 1} of {WIZARD_STEPS.length}</p>
        <p className="text-sm font-medium text-emerald-600">{WIZARD_STEPS[currentStep].label}</p>
      </div>
      <div className="mt-2 h-1.5 w-full rounded-full bg-slate-100 md:hidden">
        <div className="h-full rounded-full bg-emerald-500 transition-all duration-500" style={{ width: `${((currentStep + 1) / WIZARD_STEPS.length) * 100}%` }} />
      </div>
    </nav>
  );
}
